import Image from 'next/image'
import cn from 'classnames'
import { Marketing } from 'designsystem/Text'
import Section from 'components/common/Section'
import { SectionHeader } from 'components/marketing/SectionHeader'
import Tooltip from 'components/common/Tooltip'
import { ComponentVisualsSideBySide } from 'types/generated/contentful'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { useThemeColor } from './ThemeContext'

export const VisualsSideBySide = ({
  label,
  headline,
  subheadline,
  visual1,
  visual2,
}: ComponentVisualsSideBySide): JSX.Element => {
  const themeColor = useThemeColor()

  return (
    <Section bgColor='darkgray'>
      <SectionHeader
        label={label!}
        title={headline!}
        subline={subheadline!}
        highlight={themeColor}
        theme='dark'
      />

      <div className='relative grid items-center gap-12 lg:grid-cols-2 lg:gap-0'>
        <div className='flex flex-col items-center'>
          <div className='text-center lg:pl-20'>
            <div className='flex items-center gap-2'>
              <Marketing.H6 className='text-white'>
                {visual1!.title}
              </Marketing.H6>
              <Tooltip
                parentBgColor='neutral-on-dark'
                title={visual1!.title!}
                description={visual1!.tooltip!}
                anchor='right'
              />
            </div>

            <div
              className={cn(
                'mt-2 text-neutral-on-dark-60 font-medium text-12 simple-rich-text',
                `theme-${themeColor}`,
              )}
            >
              {documentToReactComponents(visual1!.text!.json!)}
            </div>
          </div>
          <div className='mt-4 lg:hidden'>
            <Image
              src={visual1!.mobileImage!.url!}
              alt={visual1!.mobileImage!.title!}
              width={visual1!.mobileImage!.width!}
              height={visual1!.mobileImage!.height!}
            />
          </div>
          <div className='hidden lg:block lg:mt-6'>
            <Image
              src={visual1!.desktopImage!.url!}
              alt={visual1!.desktopImage!.title!}
              width={visual1!.desktopImage!.width!}
              height={visual1!.desktopImage!.height!}
            />
          </div>
        </div>

        <div className='absolute bottom-6 left-[50%]'>
          <svg
            width={2}
            height={268}
            viewBox='0 0 2 268'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M2 0H0v4h2V0zm0 8H0v4h2V8zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4zm-2 8h2v4H0v-4zm2 8H0v4h2v-4z'
              fill='url(#paint0_linear_645_34723)'
            />
            <defs>
              <linearGradient
                id='paint0_linear_645_34723'
                x1={1.97726}
                y1={267.985}
                x2={123.901}
                y2={80.6295}
                gradientUnits='userSpaceOnUse'
              >
                <stop stopColor='#647696' stopOpacity={0} />
                <stop offset={0.333333} stopColor='#647696' stopOpacity={0.8} />
                <stop offset={0.666667} stopColor='#647696' stopOpacity={0.8} />
                <stop offset={1} stopColor='#647696' stopOpacity={0} />
              </linearGradient>
            </defs>
          </svg>
        </div>

        <div className='flex flex-col items-center'>
          <div className='text-center lg:pr-20'>
            <div className='flex items-center gap-2'>
              <Marketing.H6 className='text-white'>
                {visual2!.title}
              </Marketing.H6>
              <Tooltip
                parentBgColor='neutral-on-dark'
                title={visual2!.title!}
                description={visual2!.tooltip!}
                anchor='right'
              />
            </div>
            <div
              className={cn(
                'mt-2 text-neutral-on-dark-60 font-medium text-12 simple-rich-text',
                `theme-${themeColor}`,
              )}
            >
              {documentToReactComponents(visual2!.text!.json!)}
            </div>
          </div>
          <div className='mt-4 lg:hidden'>
            <Image
              src={visual2!.mobileImage!.url!}
              alt={visual2!.mobileImage!.title!}
              width={visual2!.mobileImage!.width!}
              height={visual2!.mobileImage!.height!}
            />
          </div>
          <div className='hidden lg:block lg:mt-6'>
            <Image
              src={visual2!.desktopImage!.url!}
              alt={visual2!.desktopImage!.title!}
              width={visual2!.desktopImage!.width!}
              height={visual2!.desktopImage!.height!}
            />
          </div>
        </div>
      </div>
    </Section>
  )
}
